export const NOTIFICATION_DURATION = 2000
export const PROJECT_PREFIX = 'metasill_media'

const TOKEN_KEY = 'access_token'
const ACCOUNT_KEY = 'account_address'
const WALLET_KEY = 'wallet'

export enum WalletEnum {
    METAMASK = 'MetaMask',
    PHANTOM = 'Phantom'
}

export const getToken = () => window.localStorage.getItem(TOKEN_KEY) || ''
export const setToken = (token: string) => window.localStorage.setItem(TOKEN_KEY, token)
export const removeToken = () => window.localStorage.removeItem(TOKEN_KEY)

export const getAccount = () => window.localStorage.getItem(ACCOUNT_KEY) || ''
export const setAccount = (account: string) => window.localStorage.setItem(ACCOUNT_KEY, account)
export const removeAccount = () => window.localStorage.removeItem(ACCOUNT_KEY)

export const setWallet = (wallet: WalletEnum) => localStorage.setItem(WALLET_KEY, wallet)
export const getWallet = () => localStorage.getItem(WALLET_KEY) as WalletEnum | ''
export const removeWallet = () => localStorage.removeItem(WALLET_KEY)
